import React from 'react';

const CloseModal = (
    {
        closeCallback,
    },
) => {
    return (
        <button className="close-modal" onClick={closeCallback}>
            &times;
        </button>
    );
};

export default CloseModal


// WEBPACK FOOTER //
// ./src/components/modal/modal-components/close-modal.jsx